import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';

import { PAGE_CONFIG as pcPageConfig} from './pcPageConfig';
import { PAGE_CONFIG as mobilePageConfig} from './mobilePageConfig';
import { CASUAL_PAGE_CONFIG as casualPageConfig } from './casualPageConfig';
import './index.scss';

const reqParams = '/retention/index';
const NightingaleRetention = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  },shallowEqual);

  // 注意：夜莺框架下，retention页面要求要能同时挂载pc框架的页面
  // 所以这里夜莺对应的组件需要用Pc Console的页面组件，同时实际上夜莺原本的页面，本迭代会新增路由单独展示
  const pageMap: any = {
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    pc_inflexion: pcPageConfig,
    casual: casualPageConfig
  };

  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]}/>
    </>
  );
};

export default NightingaleRetention;
